import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=5d71faa2&scoped=true"
import script from "./copyright.vue?vue&type=script&lang=js"
export * from "./copyright.vue?vue&type=script&lang=js"
import style0 from "./copyright.vue?vue&type=style&index=0&id=5d71faa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71faa2",
  null
  
)

export default component.exports